import { NgxSpinnerService } from 'ngx-spinner';
import { PreloaderService } from './../_services/Preloader.service';

import { User } from './../_models/User';
import { _userServicesService } from './../_services/_UserService/_userServices.service';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Device } from '../_models/Device';
import { ToasterService } from './../_services/Toaster.service';
import { DeviceService } from '../_services/_DeviceService/Device.service';
import { Observable, interval } from 'rxjs';

@Component({
  selector: 'app-User_Manage',
  templateUrl: './User_Manage.component.html',
  styleUrls: ['./User_Manage.component.css'],
})
export class User_ManageComponent implements OnInit, AfterViewInit {
  Mode = false;
  IsLoadAllUsers = false;
  AddUserMode = false;
  EditUserMode = false;
  toggleLoadAllUserSwitch = true;
  selectedDevice: string;
  Device: Device[];
  ResponseDevice: Device[];
  Users: User[];
  User: User;
  dataTable = false;
  UserdataTable = false;
  Response: any;
  updateSubscription: any;
  EditModel: User;
  dropdownList = [];
  UserIDList: Array<any> = [];
  isChecked = false;

  constructor(
    private Spinner: NgxSpinnerService,
    private DeviceService: DeviceService,
    private preloader: PreloaderService,
    private UserService: _userServicesService,
    private noti: ToasterService
  ) {}

  ngOnInit() {
    console.clear();
    this.LoadAllDevices();
  }

  ngAfterViewInit() {
    this.preloader.hide();
  }
  AddUserToggle() {
    if (this.selectedDevice != undefined) {
      this.Mode = true;
      this.AddUserMode = true;
      this.IsLoadAllUsers = false;
      this.toggleLoadAllUserSwitch = false;
    } else {
      this.noti.info('Select Device First', 'Error');
    }
  }

  EditUserToggle(Model: User) {
    if (this.selectedDevice != undefined) {
      this.EditUserMode = true;
      this.IsLoadAllUsers = false;
      this.toggleLoadAllUserSwitch = false;

      this.Mode = true;
      this.User = Model;
    } else {
      this.noti.info('Select Device First', 'Error');
    }
  }

  checkuncheckall() {
    if (this.isChecked == false) {
      this.isChecked = true;
      this.UserIDList = [];
      this.Users.forEach((item) => {
        this.UserIDList.push(item.userID);
      });
    } else {
      this.isChecked = false;
      this.UserIDList = [];
    }
  }
  selectChangeHandler(event: any) {
    if (!this.AddUserMode || !this.EditUserMode) {
      this.toggleLoadAllUserSwitch = true;
    }
    this.selectedDevice = event.target.value;
    if (this.selectedDevice == '0') {
      this.dataTable = false;
      this.UserdataTable = false;
      this.Mode = false;
      //this.IsLoadAllUsers=false;
      this.AddUserMode = false;
      this.EditUserMode = false;
      return;
    }

    if (this.AddUserMode || this.EditUserMode) return;

    this.LoadAllUser(this.selectedDevice);
  }

  LoadAllDevices() {
    // tslint:disable-next-line: no-shadowed-variable
    try {
      this.DeviceService.GetActiveDeviceList().subscribe(
        (Response) => {
          if (Response.status == 200) {
            this.Device = Response.body;
            this.preloader.hide();
          } else {
            this.noti.error('Error', Response.body);
            this.preloader.hide();
          }
        },
        (err) => {
          this.noti.error('Error', err.error);
          this.preloader.hide();
        }
      );
    } catch (error) {
      this.noti.error('Error', 'Code Crashed');
      this.preloader.hide();
    }
  }

  LoadAllUser(Devid: any) {
    console.clear();
    this.Mode = true;
    this.Spinner.show();
    // tslint:disable-next-line: no-shadowed-variable
    this.UserService.GetUserList(Devid).subscribe(
      (Response) => {
        if (Response.status == 200) {
          this.Users = Response.body;
          this.dataTable = true;
        }
        this.Spinner.hide();
        this.Mode = false;
      },
      (error) => {
        this.noti.error('Something Went Wrong', error);
        this.Spinner.hide();
        this.Mode = false;
      }
    );
  }

  CancelAddUserMode(AddUserMode: any) {
    this.AddUserMode = AddUserMode;
    this.Mode = false;
    this.toggleLoadAllUserSwitch = true;
    this.LoadAllUser(this.selectedDevice);
  }

  CancelEditUserMode(EditUserMode: any) {
    this.EditUserMode = EditUserMode;
    this.Mode = false;
    this.toggleLoadAllUserSwitch = true;
    this.LoadAllUser(this.selectedDevice);
  }
  CheckUser(event, UserID: any) {
    if (event.target.checked) {
      //var ID = Number.parseInt(UserID);
      this.UserIDList.push(UserID);
    } else {
      const index = this.UserIDList.indexOf(UserID);
      if (index > -1) {
        this.UserIDList.splice(index, 1);
      }
    }
  }

  DeleteUser(UserID: any) {
    this.Spinner.show();
    // tslint:disable-next-line: no-shadowed-variable
    if (this.selectedDevice == '') {
      return this.noti.error('Error', 'No Device Selected');
    }

    this.UserService.DeleteUser(UserID, this.selectedDevice).subscribe(
      (Response) => {
        if (Response.status == 200) {
          this.noti.success('Success', 'Successfully Deleted');
          this.LoadAllUser(this.selectedDevice);
          this.Spinner.hide();
        } else {
          this.noti.error('Error', Response.body);
          this.Spinner.hide();
        }
      },
      (err) => {
        this.noti.error('Error', err.error);
        this.Spinner.hide();
      }
    );
  }

  DeleteUserFromDB(UserID: any) {
    this.Spinner.show();
    // tslint:disable-next-line: no-shadowed-variable
    if (this.selectedDevice == '') {
      return this.noti.error('Error', 'No Device Selected');
    }

    this.UserService.DeleteUserFromDB(UserID, this.selectedDevice).subscribe(
      (Response) => {
        console.log(Response);
        if (Response.status == 200) {
          this.noti.success('Success', 'Successfully Deleted');
          this.LoadAllUser(this.selectedDevice);
          this.Spinner.hide();
        } else {
          //this.noti.error("Error", Response.body)
          this.Spinner.hide();
        }
      },
      (err) => {
        this.Spinner.hide();
        if (err.error == '404') {
          this.noti.error('Error', 'User Not Found');
        } else {
          this.noti.error('Error', err.error);
        }
      }
    );
  }

  DeleteSelectedUser() {
    console.clear();
    if (this.UserIDList.length == 0) {
      this.noti.error('Select User From List', 'Error');
    } else {
      try {
        this.UserdataTable = true;
        this.Spinner.show();

        this.UserService.DeleteSelectedUser(this.UserIDList).subscribe(
          (Response: any) => {
            console.clear();
            this.Spinner.hide();

            if (Response == 'success' || Response.status == 200) {
              this.UserdataTable = false;
              //this.MigrationSummary=Response.body;

              this.noti.success('Message', 'User Successfully transfer');
            } else {
              this.noti.error('Message', Response.body);
            }
            this.LoadAllUsersFromAllDevice();
          },
          (err) => {
            console.clear();
            this.noti.error(err.error, 'Error');
            console.log(err);
            this.Spinner.hide();
          }
        );
      } catch (error) {
        console.log(error);
      }
    }
  }

  //

  LoadAllUsersFromAllDevice() {
    console.clear();
    this.IsLoadAllUsers = !this.IsLoadAllUsers;
    if (this.IsLoadAllUsers) {
      this.UserdataTable = false;
      this.Spinner.show();
      this.UserService.GetAllUserList().subscribe(
        (Response) => {
          if (Response.status == 200) {
            this.Users = Response.body;

            this.UserdataTable = true;
          }
          this.Spinner.hide();
        },
        (error) => {
          this.noti.error('Something Went Wrong', error);
          this.Spinner.hide();
        }
      );
    } else {
      console.clear();
      this.dataTable = false;
      this.UserdataTable = false;
    }
  }
}
// DeleteSelectedUser()
//   {

//     console.clear();
//       if (this.UserIDList.length == 0 ) {
//          this.noti.error('Select User From List', "Error");
//       }
//       else {
//          var model = {
//             UserIDList: this.UserIDList.toString().split(',')
//          };

//          try {
//           this.UserdataTable=true;
//             this.Spinner.show();

//             this.UserService.DeleteSelectedUser(model).subscribe((Response: any) => {
//               console.clear();
//                this.Spinner.hide();

//                if (Response.status == 200) {
//                  this.UserdataTable=false;
//                  //this.MigrationSummary=Response.body;

//                   this.noti.success("Message", "User Successfully transfer");
//                }
//                else {
//                   this.noti.error("Message", Response.body);
//                }

//             },err=>{
//               console.clear();
//               this.noti.error(err.error, "Error");
// console.log(err);
//               this.Spinner.hide();
//             });

//          } catch (error) {
//             console.log(error);
//          }
//       }

//    }

// }
